// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    background-color: #f5f5f5;
}
  
.login-card {
    width: 100%;
    max-width: 400px;
    padding: 30px;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}
  
.login-logo {
    max-width: 200px;
    /* margin-bottom: 20px; */
}
  
.login-btn {
    background-color: #e51d1d;
    border-color: #e51d1d;
    font-weight: 500;
    padding: 10px;
}
  
.login-btn:hover, 
.login-btn:focus {
    background-color: #c51818;
    border-color: #c51818;
}
  
@media (max-width: 480px) {
    .login-card {
      padding: 20px;
      max-width: 320px;
    }
    
    .login-logo {
      max-width: 150px;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/Auth/Login.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;;IAEI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI;MACE,aAAa;MACb,gBAAgB;IAClB;;IAEA;MACE,gBAAgB;IAClB;AACJ","sourcesContent":[".login-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 100vh;\n    background-color: #f5f5f5;\n}\n  \n.login-card {\n    width: 100%;\n    max-width: 400px;\n    padding: 30px;\n    background-color: white;\n    border-radius: 8px;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n}\n  \n.login-logo {\n    max-width: 200px;\n    /* margin-bottom: 20px; */\n}\n  \n.login-btn {\n    background-color: #e51d1d;\n    border-color: #e51d1d;\n    font-weight: 500;\n    padding: 10px;\n}\n  \n.login-btn:hover, \n.login-btn:focus {\n    background-color: #c51818;\n    border-color: #c51818;\n}\n  \n@media (max-width: 480px) {\n    .login-card {\n      padding: 20px;\n      max-width: 320px;\n    }\n    \n    .login-logo {\n      max-width: 150px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
